import { createApi } from "@reduxjs/toolkit/query/react";
import { createBaseQueryWithReauth } from "../utilities/refreshTokenUtility";

export const userPermissionApi = createApi({
  reducerPath: "userPermissionApi",
  baseQuery: createBaseQueryWithReauth(`${import.meta.env.VITE_BASE_API_URL}UserPermission/`),

  endpoints: (builder) => ({
    getAllUserPermissions: builder.query({
      query: () => ({
        url: "GetUserPermissions",
        method: "GET",
      }),
    }),

    getUserPermissionsByUserId: builder.query({
      query: (userId) => ({
        url: `GetUserPermissionByUserId?userId=${userId}`,
        method: "GET",
      }),
    }),

    addUserPermission: builder.mutation({
      query: (body) => {
        return {
          url: "AddUserPermission",
          method: "POST",
          body,
        };
      },
    }),

    updateUserPermission: builder.mutation({
      query: (body) => {
        return {
          url: "UpdateUserPermission",
          method: "PUT",
          body,
        };
      },
    }),

    deleteUserPermission: builder.mutation({
      query: (id) => ({
        url: `DeleteUserPermission?id=${id}`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useGetAllUserPermissionsQuery,
  useGetUserPermissionsByUserIdQuery,
  useAddUserPermissionMutation,
  useUpdateUserPermissionMutation,
  useDeleteUserPermissionMutation,
} = userPermissionApi;

export default userPermissionApi.reducer;
